import LinearProgress from '@material-ui/core/LinearProgress';
import {useStyles} from "./styles/LoadingBarStyle";

import {Box, Typography} from "@material-ui/core";
import React, {useEffect} from "react";

function LoadingBar(props) {
    const classes = useStyles();

    const calculatePercentage = () => {
        return Number(((props.currentUploadCount / props.totalUploadCount) * 100).toFixed(2));
    }

    const isComplete = () => {
        return calculatePercentage() === 100;
    }

    useEffect(() => {
        if (isComplete()) {
            props.actionWhenComplete();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.currentUploadCount]);

    return (
        <Box className={classes.progressBarBox}>
            <Box className={classes.uploadData}>
                <Typography>Uploading data</Typography>
            </Box>
            <LinearProgress variant="determinate" value={calculatePercentage() || 0}
                            className={classes.progressBar}/>
            <Box className={classes.barState}>
                <Typography>Uploading {calculatePercentage() || 0}%</Typography>
            </Box>
            <Typography className={classes.uploadText}>
                {isComplete()
                    ? '파일 업로드가 완료되었습니다.'
                    : '파일을 업로드 중입니다.'
                }
            </Typography>
        </Box>
    )
}

export default LoadingBar;
